import React, { useEffect, useState } from 'react';
import { collection, getDocs, orderBy, query } from 'firebase/firestore';
import { db } from '../utils/firebase';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';

const SupportTickets = () => {
  const [tickets, setTickets] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchTickets = async () => {
      const ref = collection(db, 'supportTickets');
      const q = query(ref, orderBy('createdAt', 'desc'));
      const snapshot = await getDocs(q);

      const ticketList = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
      }));

      setTickets(ticketList);
    };

    fetchTickets();
  }, []);

  return (
    <div className="min-h-screen bg-gray-900 text-white">
      <Header />
      <div className="p-8">
        <h1 className="text-3xl font-bold mb-6 text-white">📬 Support Tickets</h1>
        <div className="bg-gray-800 shadow-md rounded-lg overflow-x-auto border border-gray-700">
          <table className="min-w-full text-sm">
            <thead className="bg-gray-700 text-left">
              <tr>
                <th className="px-4 py-2 text-gray-300">User Email</th>
                <th className="px-4 py-2 text-gray-300">Status</th>
                <th className="px-4 py-2 text-gray-300">Created At</th>
              </tr>
            </thead>
            <tbody>
              {tickets.map((ticket) => (
                <tr
                  key={ticket.id}
                  onClick={() => navigate(`/admin/support/${ticket.id}`)}
                  className="border-t border-gray-700 hover:bg-gray-700 cursor-pointer"
                >
                  <td className="px-4 py-2 text-white">{ticket.email}</td>
                  <td className="px-4 py-2 capitalize text-white">{ticket.status}</td>
                  <td className="px-4 py-2 text-gray-300">
                    {ticket.createdAt?.toDate?.().toLocaleString?.() || 'N/A'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default SupportTickets;
